import React, {useEffect, useState} from "react";
import Layout from "../../layout/Layout/Layout";
import {Box} from "@mui/material";
import {DataGrid, GridCellParams} from "@mui/x-data-grid";
import axios from "axios";
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import {toast} from "react-toastify";
import Loader from "../loader/loader";
import {APP_CONFIGURATION} from "../../app-config/configuration";


interface TeamCaption {
    id: number;
    fullName: string;
    emailAddress: string;
    phoneNumber: string | null;
    instagramHandle: string;
    facebookHandle: string;
    linkedInHandle: string | null;
    twitterHandle: string;
    youtubeHandle: string;
    motivation: string;
    experience: string;
    uniqueValue: string;
    previousMentorshipExperience: string;
    strategy: string;
    leadershipExpectations: string;
    referralSource: string;
}



const TeamCaption = () => {
    const [blogData, setBlogData] = useState<TeamCaption[]>([]);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const onOpenModal = (id: any) => {
        setOpen(true);
        setDeleteId(id)
    }
    const onCloseModal = () => setOpen(false);

    const handleDelete = () => {
        const payload = {
            id: deleteId
        }
        setLoading(true)
        // @ts-ignore
        axios.post(`${APP_CONFIGURATION.APP_CONSTANT.API_URL}api/v0/deleteBlog`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
            .then((res) => {
                if (res.status) {
                    setLoading(false)
                    toast.success("Deleted Successfully");
                    onCloseModal()
                    getAllBlog()
                }
            })
            .catch((err) => {
                // Handle the error
            });
    }
    const handleEdit = (id: string) => {
        window.location.replace(`/create-blog/${id}`);
    }
    const columns = [
        {
            field: "srNo",
            headerName: "Sr. No.",
            width: 60,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as number}</div>
            ),
        },
        {
            field: "fullName",
            headerName: "Full Name",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "emailAddress",
            headerName: "Email Address",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "phoneNumber",
            headerName: "Phone Number",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "instagramHandle",
            headerName: "Instagram Handle",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "facebookHandle",
            headerName: "Facebook Handle",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "linkedInHandle",
            headerName: "LinkedIn Handle",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "twitterHandle",
            headerName: "Twitter Handle",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "youtubeHandle",
            headerName: "YouTube Handle",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "motivation",
            headerName: "Motivation",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "experience",
            headerName: "Experience",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "uniqueValue",
            headerName: "Unique Value",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "previousMentorshipExperience",
            headerName: "Previous Mentorship Experience",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "strategy",
            headerName: "Strategy",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "leadershipExpectations",
            headerName: "Leadership Expectations",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "referralSource",
            headerName: "Referral Source",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
    ];


    useEffect(() => {
        getAllBlog()
    }, []);
    const getAllBlog = () => {
        setLoading(true)
        axios
            .get(`https://gatewayapi-uat.worldtradingleagues.com/api/v1/ifi/all-teams-data`)
            .then((res) => {
                console.log('res' , res.data)
                const blogDataWithKeys = res.data.map((item: TeamCaption, index: number) => ({
                    ...item,
                    id: item.id.toString(),
                    srNo: index + 1, // Add a new property for Sr. No.
                }));
                setBlogData(blogDataWithKeys);
                setLoading(false)
            })
            .catch(() => {
            });
    }

    // @ts-ignore
    return (
        <>
            <Layout>
                <main id="main" className="main">
                    <div className="pagetitle mt-3">
                        <h1>Team Caption</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    Home
                                </li>
                                <li className="breadcrumb-item active">Team Caption</li>
                            </ol>
                        </nav>
                    </div>
                    <section className="section dashboard">
                        <Loader loading={loading}/>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 mt-5">
                                    <Box>
                                        <DataGrid
                                            rows={blogData}
                                            columns={columns}
                                            pagination
                                            // rowCount={blogData.length}
                                            // pageSizeOptions={[10, 15, 25]}
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Modal open={open} onClose={onCloseModal} center>
                    <div className='p-5 text-center'>
                        <h3>Are You Sure You Want to Delete?</h3>
                        <div className="mt-3">
                            <button className="btn btn-danger ml-5" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-secondary mr-4" style={{marginLeft: '10px'}}
                                    onClick={onCloseModal}>Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
            </Layout>
        </>
    );
};

export default TeamCaption;
